import React from "react";
import { Seo } from "@/components/shared/Seo";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const NotFound: React.FC = () => {
  return (
    <>
      <Seo>
        <title>Page not found | Adi Astra</title>
        <meta name="robots" content="noindex" />
      </Seo>
      <div className="container mx-auto px-4 py-24 text-center">
        <p className="text-base font-semibold text-primary tracking-wide uppercase">
          404
        </p>
        <h1 className="mt-2 text-4xl font-bold tracking-tight sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-4 text-lg text-muted-foreground max-w-xl mx-auto">
          That page doesn&rsquo;t exist. The free five-minute test does, though.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md text-md font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-12 px-6 py-3"
          >
            Go to the homepage <ArrowRight className="ml-2 h-5 w-5" />
          </Link>
          <Link
            to="/pricing"
            className="inline-flex items-center justify-center rounded-md text-md font-medium border border-input bg-background hover:bg-accent h-12 px-6 py-3"
          >
            See the rate card
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
